import { useAppSelector } from '../../redux/hooks.ts'
import { selectUser } from '../../features/user/user.slice.ts'
import { ROLE_VIEWONLY } from '../../router/roles.ts'

export const useIsSuperViewer = (): boolean => {
  const userInfo = useAppSelector(selectUser)
  return userInfo.role === ROLE_VIEWONLY
}
